























































































































































































































































































































import { Vue, Component, Watch } from 'vue-property-decorator';
import StatusPanel from '@/components/BasePriceStatus.vue';
import BaseContainer from '@/components/BaseContainer.vue';
import { formRules } from '@/common/util/validator';
import { Inquiry, CspOrder, PriceList } from '@/http';
import publicFunc from '@/common/util/publicFunc';
import { PaginationPanel } from '@/components';
import { default as DataPanel } from '@/components/DataPanel.vue';
import { enums } from '@/common/enums';
export interface Pagination {
    skip: number;
    count: number;
    currentPage: number;
}
@Component({
    components: { StatusPanel, BaseContainer, PaginationPanel, DataPanel },
})
export default class freightEdit extends Vue {
    public publicFunc: any = publicFunc;
    public freightUnitType = enums.freightUnitType;
    public loading = false;
    public rePagin = false;
    public formRules = formRules;
    public id: any = '';
    public titleText = '';
    public carLengthList: any = [];
    public currentBtn: any = [];
    public priceListType: any;

    public paginationOptions = {
        skip: 0,
        count: 10,
        currentPage: 1,
    };
    public pageSizes = [10,20,30];
    public pageSize: number = 10;
    public firstPageBtnDisabled = true;
    public lastPageBtnDisabled = false;
    public handleCurrentChange(val) {
        console.log('onPaginationChange', val);
        this.firstPageBtnDisabled = val === 1 ? true : false;
        this.lastPageBtnDisabled = val === Math.ceil(this.total / this.paginationOptions.count) ? true : false;
        this.paginationOptions.currentPage = val;
        this.paginationOptions.skip = (this.paginationOptions.currentPage - 1) * this.paginationOptions.count;
        console.log('this.paginationOptions~', this.paginationOptions);
    }
    public handleSizeChange(val) {
        console.log('handleSizeChangeval' + JSON.stringify(val));

        this.paginationOptions.count = val;
        this.paginationOptions.currentPage = 1;
        this.handleCurrentChange(this.paginationOptions.currentPage);
        if (Math.ceil(this.total / val) < this.paginationOptions.currentPage) {
            this.paginationOptions.skip = 0;
        } else {
            this.paginationOptions.skip = (this.paginationOptions.currentPage - 1) * this.paginationOptions.count;
        }
    }
    public async mounted() {
        this.id = this.$route.query.id;
        let res = await Inquiry.GetDicDetailList({
            typeName: 'carLength',
            count: -1,
        });
        this.carLengthList = res.map((v) => {
            return v.name;
        });

        res.forEach((item) => {
            this.colData.push({
                carLength: item.name,
            });
        });
        let res2 = await PriceList.GetPriceListItem(this.id);
        res2.time = [];
        this.formData = res2;
        this.priceListType = res2.priceListType;
        console.log('this.priceListType======>', this.priceListType);

        this.formData.time = [this.formData.beginDate, this.formData.endDate];
        // this.currentBtn = JSON.parse(JSON.stringify(this.formData.titleList));
        // if (res2.priceListType == 1) {
        //     this.currentBtn2 = [];
        //     let temp = [];
        //     this.formData.titleList.forEach((i) => {
        //         temp.push(i + '（元/车）');
        //     });
        //     this.currentBtn2 = temp;
        //     // console.log('1111111111', JSON.stringify(this.currentBtn2));
        // } else if (res2.priceListType == 3) {
        //     this.currentBtn2 = [];
        //     this.currentBtn2 = JSON.parse(JSON.stringify(this.formData.titleList));
        //     console.log('22222222222', JSON.stringify(this.currentBtn2));
        // } else {
        //     this.currentBtn2 = [];
        //     let temp = [];
        //     this.formData.titleList.forEach((i) => {
        //         temp.push(i + '（元/吨）');
        //     });
        //     this.currentBtn2 = temp;
        //     // console.log('33333333', JSON.stringify(this.currentBtn2));
        // }
        // console.log('this.currentBtn2' + JSON.stringify(this.currentBtn2));
        this.loadData();
    }

    async querySearchcys(queryString, cb) {
        this.formData.carrierId = '';
        let res = await PriceList.carrierList(this.formData.carrierName);
        console.log(res);
        let result = [];
        res.data.forEach((dd) => {
            let xx = {
                value: dd.name,
                id: dd.id,
            };
            result.push(xx);
        });
        //this.selectList = result;
        cb(result);
    }
    selectCys(data) {
        this.formData.carrierId = data.id;
    }

    public currentBtn2: any = [];
    public colData: any = [];
    public $refs: {
        formData: HTMLFormElement;
        pagination: HTMLFormElement;
    };
    public formData: any = {};
    public searchValue: any = {
        delivery: '',
        arrival: '',
    };
    public resetSearchValue() {
        this.searchValue = { delivery: '', arrival: '' };
        this.loadData();
    }
    updateBtn(item, index) {
        console.log('this.currentBtn' + JSON.stringify(this.currentBtn));
        if (this.currentBtn.includes(item)) {
            this.currentBtn.splice(this.currentBtn.indexOf(item), 1);
        } else {
            this.currentBtn.push(item);
        }
    }

    public saveData: any = [];
    public flag = false;
    numberChange(e,name,index,number){
        console.log('eee',e);
        if(number){
            e.target.value= e.target.value.match(/\d{1,9}(\.\d{0,4})?/) ? e.target.value.match(/\d{1,9}(\.\d{0,4})?/)[0] : ''
            this.tableData[index][name] = e.target.value;
        }else{
            this.tableData[index][name] = e.target.value;
        }
     console.log('numberchange',name,index,this.tableData);           
    }
    selecChange(e,name,index,number){        
        if(name=='pricingMode'){
            this.tableData[index][name] = e;
            if(e==1){
                this.tableData[index]['pricingModeStr'] = '元/车'
            }else if(e==2){
                this.tableData[index]['pricingModeStr'] = '元/吨'
            }
        }else{
            this.tableData[index][name] = e;
        }
        
        console.log('selectrow-->',e,index,this.tableData);
    }
    numberChange1(i, row, number) {
        this.flag = false;
        //let temp = i.priceValue.toString();
        if(number){
            let temp = i.toString();
            temp = temp.replace(/。/g, '.');
            temp = temp.replace(/[^\d.]/g, ''); //清除"数字"和"."以外的字符
            temp = temp.replace(/^\./g, ''); //验证第一个字符是数字
            temp = temp.replace(/\.{2,}/g, ''); //只保留第一个, 清除多余的
            temp = temp.replace('.', '$#$').replace(/\./g, '').replace('$#$', '.');
            temp = temp.replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3'); //
            //i.priceValue = temp;
            i = temp;
        }        
        console.log('row' + JSON.stringify(row));
        this.saveData.forEach((item) => {
            if (item.id == row.id) {
                console.log('true');
                this.flag = true;
                row = JSON.parse(JSON.stringify(item.value));
            }
        });
        if (!this.flag) {
            console.log('push');
            this.saveData.push({
                id: row.id,
                value: row,
            });
        }
        console.log('saveData' + JSON.stringify(this.saveData));
    }
    save() {
        // console.log('this.formData' + JSON.stringify(this.formData));
        // console.log('this.tableData' + JSON.stringify(this.tableData));

        this.$refs.formData.validate(async (valid) => {
            if (valid) {
                let result = await PriceList.CheckPriceListInPeriod({
                    id: this.id,
                    carrierId: this.formData.carrierId,
                    beginDate: this.formData.time[0],
                    endDate: this.formData.time[1],
                    priceListType: this.formData.priceListType,
                });
                if (result) {
                    //this.$alert('该承运商合同价与已有合同价的有效期存在重合，确定保存？');
                     this.$confirm('该合同价与已有合同价的有效期存在重合，确定保存？', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning',
                    })
                        .then(async () => {
                            let obj = {
                            id: this.id,
                            carrierId: this.formData.carrierId,
                            beginDate: this.formData.time[0],
                            endDate: this.formData.time[1],
                            priceListDetails:this.tableData
                        };
                        await PriceList.UpdatePriceList(obj);
                        this.$message.success('保存成功');
                        this.$router.push('/fleetContractPriceConfig');
                        //this.loadData();

                    })
                }else{
                    let obj = {
                    id: this.id,
                    carrierId: this.formData.carrierId,
                    beginDate: this.formData.time[0],
                    endDate: this.formData.time[1],
                    priceListDetails:this.tableData
                    };
                    await PriceList.UpdatePriceList(obj);
                    this.$message.success('保存成功');
                    this.$router.push('/fleetContractPriceConfig');
                    //this.loadData();
                }

                // let detailList = [];
                // this.saveData.forEach((i) => {
                //     detailList.push({
                //         id: i.id,
                //         priceContent: i.value.priceContent,
                //     });
                // });
                // console.log('detailList' + JSON.stringify(detailList));
                // let obj = {
                //     id: this.id,
                //     beginDate: this.formData.time[0],
                //     endDate: this.formData.time[1],
                //     detailList: detailList,
                // };
                // await PriceList.UpdatePriceList(obj);

                // let obj = {
                //     id: this.id,
                //     carrierId: this.formData.carrierId,
                //     beginDate: this.formData.time[0],
                //     endDate: this.formData.time[1],
                //     priceListDetails:this.tableData
                // };
                // await PriceList.UpdatePriceList(obj);
                // this.$message.success('保存成功');
                // this.loadData();
            }
        });
    }
    del(row) {
        this.$confirm('确认删除吗?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
        })
            .then(() => {
                PriceList.DeletePriceListDetail(row.id).then(() => {
                    this.$message.success('删除成功');
                    this.loadData();
                });
            })
            .catch(() => {});
        // this.tableData.splice(index - 1, 1);
        // this.tableData.forEach((item, index) => {
        //     item.index = index + 1;
        // });
    }
    effective() {
        this.$confirm('确认立即生效合同价?', '合同价生效', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
        })
            .then(() => {
                PriceList.PriceListTakeEffect(this.id).then(() => {
                    this.$message.success('合同价生效成功!');
                    this.$router.push('/fleetContractPriceConfig');
                });
            })
            .catch(() => {});
    }

    public async exportExcel() {
        let data = await PriceList.ExportPriceListExcel(this.id);
        // if (data && data.attachmentUrl) {
        //     window.open(data.attachmentUrl);
        // } else {
        //     this.$message.warning('导出失败!');
        // }
    }

    public async download() {
        let data = await PriceList.GetCdTemplate();
        // if (data && data.attachmentUrl) {
        //     window.open(data.attachmentUrl);
        // } else {
        //     this.$message.warning('模板下载失败!');
        // }
    }

    /* 错误类型 */
    public errorType: number = null;
    public dialogVisible = false;
    public errList: any = [];
    public batchImportList: any = [];
    async updateExcel(e: any) {
        let param = new FormData();
        const file = e.file;
        param.append('excel', file);
        param.append('priceListType','3');
        console.log('param' + param);
        let res = await PriceList.ImportSorcListDetail(this.id, param);
        this.$message.success('导入成功!');
        let starttime ='';
            if(res.beginDate){
              starttime = res.beginDate.split('/').join('-');              
            }
            let endtime ='';
            if(res.beginDate){
              endtime = res.endDate.split('/').join('-');              
            }
            if(starttime&&endtime){
              this.formData.time=[starttime,endtime];   
            }else{
              this.formData.time = [];
            }
        this.formData.carrierId = res.carrierId;
        this.formData.carrierName = res.carrierName;
        await this.loadData();
        return;
        if (res.validity) {
            await CspOrder.AddExcelData(res);
            this.loadData();
            this.$message.success('导入成功!');
        } else {
            this.errorType = res.validityStatus;
            if (this.errorType == 0) {
                this.$message.success('操作成功!');
                this.loadData();
            }
            if (this.errorType == 1) {
                if (res.orderList.length == 0) {
                    this.$message.error('Excel表格为空，无法上传！');
                } else {
                    this.$message.error('一次最多上传100条订单，请删减后重新上传！');
                }
            }
            if (this.errorType == 2) {
                this.errList = [];
                this.errList = res.errRowCellList;
                this.batchImportList = [];
                console.log('res.orderList' + JSON.stringify(res.orderList));
                res.orderList.forEach((item) => {
                    this.batchImportList.push(item);
                });
                this.dialogVisible = true;
                console.log('this.errList' + JSON.stringify(this.errList));
            } else if (this.errorType == 3) {
                this.errList = res.repeatRow;
                this.batchImportList = [];
                res.orderList.forEach((item) => {
                    this.batchImportList.push(item);
                });
                this.dialogVisible = true;
                console.log('this.errList' + JSON.stringify(this.errList));
            }
        }
    }

    public searchPagin: Pagination = {
        skip: 0,
        count: 10,
        currentPage: 1,
    };

    public searchFunc() {
        this.handleCurrentChange(1);
        this.searchPagin.skip = 0;
        this.loadData();
    }
    public async onPaginationChange(pagin: Pagination) {
        this.searchPagin = pagin;
        this.loadData();
    }
    public tableData: any = [];
    public total = 0;
    public priceContentList: any = [];
    public async loadData() {
        this.loading = true;
        try {
            let res = await PriceList.GetPriceListDetailList({
                ...this.searchValue,
                priceListId: this.id,
                skip: this.searchPagin.skip,
                count: -1,
            });

            this.tableData = res.data;

            let skip = this.searchPagin.skip;
            this.tableData.map((item, index) => {
                // item.priceContent.forEach((i) => {
                //     if (this.priceListType == 1) {
                //         i.titleName = i.titleName + '（元/车）';
                //     }
                //     if (i.priceValue == '') {
                //         i.priceValue = undefined;
                //     }
                // });
                // console.log('item.priceContent======>', JSON.stringify(item.priceContent));
                item.index = skip++ + 1;
            });
            // this.tableData.forEach((item, index) => {
            //     let res = this.saveData.filter((v) => v.id == item.id)[0];
            //     if (res) {
            //         Vue.set(this.tableData, index, res.value);
            //     }
            // });
            this.$refs.pagination.setPage(this.searchPagin.currentPage);            
            this.total = res.total?res.total:0;
            this.loading = false;
        } catch {
            this.loading = false;
        }
    }
}
